import { useCallback } from 'react';
import { NotificationService } from '../services/notificationService';

/**
 * Custom hook for notification management using @mantine/notifications
 * Provides all 4 notification types with memoized callbacks
 *
 * Usage:
 * ```ts
 * const { showSuccess, showError, showWarning, showInfo } = useNotifications();
 * showSuccess('Operation completed');
 * showError('An error occurred');
 * ```
 */
export const useNotifications = () => {
  // ✅ Memoize functions to prevent infinite re-render loops
  // NotificationService is static, so empty dependencies are safe
  const showSuccess = useCallback((message: string) => {
    NotificationService.showSuccess(message, false);
  }, []);

  const showError = useCallback((message: string) => {
    NotificationService.showError(message, false);
  }, []);

  const showWarning = useCallback((message: string) => {
    NotificationService.showWarning(message, false);
  }, []);

  const showInfo = useCallback((message: string) => {
    NotificationService.showInfo(message, false);
  }, []);

  return {
    showSuccess,
    showError,
    showWarning,
    showInfo,
  };
};
